import Repository from '../Repository'

export default {
  templates: (params) => {
    return Repository.get(
      '/line-messages/templates', {params},
    )
  },
  history: (params) => {
    return Repository.get(
      '/line-messages/history', {params},
    )
  },
  delTemplate: (templateId) => {
    return Repository.delete('/line-messages/templates/' + templateId)
  },
  drafts: (params) => {
    return Repository.get(
      '/line-messages/drafts', { params }
    )
  },
  filters: () => {
    return Repository.get('/line-messages/filters')
  },
  show: (id) => {
    return Repository.get('/line-messages/' + id)
  },
  update: (payload) => {
    return Repository.put('/line-messages/' + payload.id, payload)
  },
  save: (payload) => {
    return Repository.post('/line-messages', payload)
  },
  getRemindTemplate: () => {
    // get branch id from local storage
    return Repository.get(`/line-messages/remind`)
  },
  getLineInfo: () => {
    return Repository.get(`/line-messages/quota/info`)
  },
  getThankTemplates: () => {
    return Repository.get(`/line-messages/thanks`)
  },
  saveRemindTemplate: (payload) => {
    return Repository.post('/line-messages/remind', payload)
  },
  saveThankTemplate: (payload) => {
    return Repository.post('/line-messages/thanks', payload)
  },
  getUsersWithLineIdSentSuccessfully: (payload) => {
    const lineMessagesId = payload?.lineMessagesId
    if (!lineMessagesId) {
      return Repository.get(`/line-messages/user-sent-messages`)
    }
    return Repository.get(`/line-messages/user-sent-messages/?line_message_filter_id=${lineMessagesId}`)
  },
  // get estimated-delivery
  getEstimatedDelivery: (payload) => {
    return Repository.post(`/line-messages/estimated-delivery`, payload)
  },
}
